import axios from 'axios';

/**
 * [backend env url/api]
 */

export const api = axios.create({
  baseURL: process.env.VUE_APP_BACK_URL,
  // timeout: 2000,
  headers: {
    'Access-Control-Allow-Origin': process.env.VUE_APP_BACK_URL,
  },
});